import { defineMessages } from 'react-intl';

import config from '@plone/volto/registry';

// Used for copied FacetSchema
import {
  hasDateOperation,
  hasNonValueOperation,
} from '@plone/volto/components/manage/Blocks/Search/utils';

// Copied from "@plone/volto/src/components/manage/Blocks/Search/schema.js" version 16.20.1 and trimmed down to only used as it isn't exported
const messages = defineMessages({
  facet: {
    id: 'Facet',
    defaultMessage: 'Facet',
  },
  field: {
    id: 'Field',
    defaultMessage: 'Field',
  },
  facetWidget: {
    id: 'Facet widget',
    defaultMessage: 'Facet widget',
  },
  multipleChoices: {
    id: 'Multiple choices?',
    defaultMessage: 'Multiple choices?',
  },
});

// Copied from "@plone/volto/src/components/manage/Blocks/Search/schema.js" version 16.20.1 as it isn't exported
const FacetSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.facet),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['field', 'type', 'multiple'],
    },
  ],
  properties: {
    field: {
      title: intl.formatMessage(messages.field),
      widget: 'select_querystring_field',
      vocabulary: { '@id': 'plone.app.vocabularies.MetadataFields' },
      filterOptions: (options) => {
        // Only allows indexes that provide simple, fixed vocabularies.
        // This should be improved, together with the facets. The querystring
        // widget implementation should serve as inspiration for those dynamic
        // types of facets.
        return Object.assign(
          {},
          ...Object.keys(options).map((k) =>
            Object.keys(options[k].values || {}).length ||
            hasNonValueOperation(options[k].operations) ||
            hasDateOperation(options[k].operations)
              ? { [k]: options[k] }
              : {},
          ),
        );
      },
    },
    type: {
      title: intl.formatMessage(messages.facetWidget),
      choices: config.blocks.blocksConfig.search.extensions.facetWidgets.types.map(
        ({ id, title }) => [
          id,
          `${intl.formatMessage({ id: id, defaultMessage: title })}`,
        ],
      ),
      defaultValue: config.blocks.blocksConfig.search.extensions.facetWidgets.types.find(
        ({ isDefault }) => isDefault,
      ).id,
    },
    multiple: {
      type: 'boolean',
      title: intl.formatMessage(messages.multipleChoices),
      default: false,
    },
  },
  required: ['field'],
});

export function repeaterSourceSchemaFacets({ intl }) {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['searchPage', 'facet'],
      },
    ],
    properties: {
      searchPage: {
        title: 'Search page',
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['@id', 'title'],
        allowExternals: false,
        selectableTypes: ['Document', 'Plone Site'],
      },
      facet: {
        title: 'Facet',
        widget: 'object',
        schema: FacetSchema({ intl }),
      },
    },
  };
}
